import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from '../../../shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from '../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { Entity, HeaderMenuType } from '../../../shared/store/view/types';
import { ModuleId } from '../../../shared/store/navigation/types';
import { ClaimTypeDetailsComponent } from './claim-type-details/claim-type-details.component';
import { ClaimTypeEditComponent } from './claim-type-edit/claim-type-edit.component';
import { ClaimTypeCreateComponent } from './claim-type-create/claim-type-create.component';

const routes: Routes = [
  {
    path: 'Insurance/ClaimTypes',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.ClaimType,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: ClaimTypeDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.ClaimType,
          breadcrumb: { label: ' ', alias: 'claimTypeDetails' },
        },
      },
      {
        path: 'Edit/:id',
        component: ClaimTypeEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.ClaimType,
          breadcrumb: { label: ' ', alias: 'claimTypeEdit' },
        },
      },
      {
        path: 'Create',
        component: ClaimTypeCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.ClaimType,
          breadcrumb: { label: ' ', alias: 'claimTypeCreate' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClaimTypeRoutingModule {}
